export const isAdditiveSelectEvent = (event) => Boolean(event?.shiftKey || event?.ctrlKey || event?.metaKey);
